import React from 'react';
import history from '../../history';

const nav = route => {
  history.push(route);
};

const menuItems = [
  {
    label: 'General Settings',
    icon: 'fas fa-cog',
    onClick: () => nav('/UCG1/general'),
  },
  {
    label: 'Mail Settings',
    icon: 'fas fa-envelope-open-text',
    onClick: () => nav('/UCG1/mail'),
  },
  {
    label: 'Archive Settings',
    icon: 'fas fa-archive',
    onClick: () => nav('/UCG1/archive'),
  },
  {
    label: 'LDAP Settings',
    icon: 'fas fa-address-book',
    onClick: () => nav('UCG1/ldap'),
  },
  {
    label: 'Features',
    icon: 'fas fa-toggle-on',
    onClick: () => nav('/UCG1/features'),
  },
  {
    label: 'Print Settings',
    icon: 'fas fa-print',
    onClick: () => nav('/UCG1/print'),
  },
  {
    label: 'Bifrost Settings',
    icon: 'fas fa-rainbow',
    onClick: () => nav('/UCG1/bifrost'),
  },
  {
    label: 'IBS Settings',
    icon: 'fas fa-toilet',
    onClick: () => nav('/UCG1/ibs'),
  },
  {
    label: 'Twilio Settings',
    icon: 'fas fa-sms',
    onClick: () => nav('/UCG1/twilio'),
  },
  {
    label: 'Fleetcross Settings',
    icon: 'fas fa-cross',
    onClick: () => nav('/UCG1/fleetcross'),
  },
  {
    label: 'Loyalty Settings',
    icon: 'fas fa-crown',
    onClick: () => nav('/UCG1/loyalty'),
  },
  {
    label: 'OAuth Settings',
    icon: 'fas fa-at',
    onClick: () => nav('/UCG1/oauth'),
  },
];

const ConfigIndex = () => {
  const renderMenuItems = () => {
    return menuItems.map((item, i) => {
      if (item.hide && item.hide()) {
        return null;
      }

      return (
        <div className="crud-item-wrapper" key={i}>
          <div className="panel flex-panel crud-item list-item" onClick={item.onClick}>
            <i className={item.icon} />
            {item.label}
          </div>
        </div>
      );
    });
  };

  return (
    <div className="dashboard">
      <div id="dashboard">
        <div className="create-wrapper">{renderMenuItems()}</div>
      </div>
    </div>
  );
};

export default ConfigIndex;
